import { BrowserModule }                    from '@angular/platform-browser';
import { RouterModule }                     from '@angular/router';
import { NgModule }                         from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule }          from '@angular/platform-browser/animations';
import { FileDropDirective, FileSelectDirective } from 'ng2-file-upload';

import { CalendarModule }                   from 'angular-calendar';
import { NgxDatatableModule }               from '@swimlane/ngx-datatable';
import { AgmCoreModule }                    from '@agm/core';
import { SqueezeBoxModule }                 from 'squeezebox';
import { routes, AppRoutingModule }         from './app-routing.module';
import { UIModule }                         from './ui/ui.module';
import { NIModule }                         from './ni-components/ni.module';
import { AppComponent }                     from './app.component';
import { DefaultLayoutComponent }           from './layouts/default/default.component';
import { BoxedLayoutComponent }             from './layouts/boxed/boxed.component';
import { DefaultCLayoutComponent }          from './layouts/default-c/default-c.component';
import { BoxedCLayoutComponent }            from './layouts/boxed-c/boxed-c.component';
import { ExtraLayoutComponent }             from './layouts/extra/extra.component';
import { homepage}                          from './pages/home/home';
import { ChartModule }                      from 'angular2-chartjs';
import { PageTradeTimeline }                from './pages/trade-back/trade-timeline';
import { PageTradeList }                    from './pages/trade-back/trade-list';
import { PageTradeDelivery }                from './pages/trade-back/trade-delivery';
import { PageTradeDeliveryDetail }          from './pages/trade-back/trade-delivery-detail';
import { tradeDialog }                      from './pages/trade-back/trade-delivery';
import { tradeListDialog}                   from './pages/trade-back/trade-list';
import { WarningTradBackDialog } from './pages/trade-back/trade-delivery';


import { HttpModule } from '@angular/http';


//autocomplete multi select
import { AngularMultiSelectModule } from 'angular4-multiselect-dropdown/angular4-multiselect-dropdown';
//ToastrModule
//import { ToastrModule } from 'ngx-toastr';

import { PageNotFoundComponent }            from './pages/not-found/not-found.component';
import { PageLayoutsComponent }             from './pages/layouts/layouts.component';

//product
import { PageProduct }     from './pages/product/product';
import { PageProductAdd }  from './pages/product/product-form-add';
import { PageProductEdit }  from './pages/product/product-form-edit';
//material
import { PageMaterial } from './pages/material/material';
import { PageMaterialAdd } from './pages/material/material-form-add';
import { PageMaterialEdit } from './pages/material/material-form-edit';

//customer
import { PageCustomer }  from './pages/customer/customer';
import { PageCustomerAdd } from './pages/customer/customer-form-add';
import { PageCustomerEdit } from './pages/customer/customer-form-edit';
import { customerLoadingEditDialog } from './pages/customer/customer-form-edit';
import { customerLoadingAddDialog } from './pages/customer/customer-form-add';

//supplier
import { PageSupplier }  from './pages/supplier/supplier';
import { PageSupplierAdd } from './pages/supplier/supplier-form-add';
import { PageSupplierEdit } from './pages/supplier/supplier-form-edit';
import { supplierLoadingAddDialog } from './pages/supplier/supplier-form-add';
import { supplierLoadingEditDialog } from './pages/supplier/supplier-form-edit';

//bom
//import { PageBom }  from './pages/bom/bom';
//Machine
import { PageMachine } from './pages/machine/machine';
import { machineDialog } from './pages/machine/machine';
import { WarningMachineDialog } from './pages/machine/machine';

//approve
import { PageApprove } from './pages/approve/approve';
import { approveDialog } from './pages/approve/approve';
import { WarningApproveDialog } from './pages/approve/approve';

//permission
import { PagePermission } from './pages/permission/permission';
import { pmDialog } from './pages/permission/permission';
import { WarningPmDialog } from './pages/permission/permission';

//control chart setting

//import { PageControlChartSetting } from './pages/control-chart-setting/control-chart-setting-cs';
//import { controlChartSettingDialog } from './pages/control-chart-setting/control-chart-setting-cs';
//import { WarningControlChartSettingDialog } from './pages/control-chart-setting/control-chart-setting-cs';

import { PageControlChartSetting } from './pages/control-chart-setting/control-chart-setting';
import { controlChartSettingDialog } from './pages/control-chart-setting/control-chart-setting';
import { WarningControlChartSettingDialog } from './pages/control-chart-setting/control-chart-setting';


import { PageProductStandard} from './pages/control-chart-setting/product-standard';
import { productStandardDialog } from './pages/control-chart-setting/product-standard';
import { WarningProductStandardDialog } from './pages/control-chart-setting/product-standard';

import { PageCheckSheetSetting } from './pages/check-sheet-setting/check-sheet-setting';
import { WarningCheckSheetSettingDialog } from './pages/check-sheet-setting/check-sheet-setting';
import { checkSheetSettingDialog } from './pages/check-sheet-setting/check-sheet-setting';
//operator setting
import { PageOperatorSetting } from './pages/operator-setting/operator-setting';
import { operatorSettingDialog } from './pages/operator-setting/operator-setting';
import { WarningOperatorSettingDialog } from './pages/operator-setting/operator-setting';
//process
import { PageProcess } from './pages/process/process';
import { processDialog } from './pages/process/process';
import { WarningProcessDialog } from './pages/process/process';
//plan process
import { PagePlanProcess } from './pages/plan-process/plan-process';
import { processPlanDialog } from './pages/plan-process/plan-process';
import { WarningPlanProcessDialog } from './pages/plan-process/plan-process';
//user
import { PageUser } from './pages/user/user';
import { PageUserPermission } from './pages/user/permission';
import { PageUserAdd } from './pages/user/user-add';
import { userAddDialog } from './pages/user/user-add';
import { userDialog } from './pages/user/user';
import { PageUserEdit } from './pages/user/user-edit';
import { userEditDialog } from './pages/user/user-edit';
//production line
import { PageProductionLine } from './pages/production-line/production-line';
import { WarningLineDialog } from './pages/production-line/production-line';
import { lineDialog } from './pages/production-line/production-line';

//stock planing
import { PageStockPlainning } from './pages/stock/stock-planning';

//sale & delivery plan
import { PagePlanSale } from './pages/plan-sale/plan-sale';
import { saleDeliveryPlanDialog } from './pages/plan-sale/plan-sale';
import { WarningsaleDeliveryPlanDialog} from './pages/plan-sale/plan-sale';
//diaglog
import { ProductAddDialog }                  from './pages/product/product-form-add';
import { ProductEditDialog}                  from './pages/product/product-form-edit';
import { ProductDiableDialog }               from './pages/product/product';
import { MaterailDiableDialog }              from './pages/material/material';
import { MaterailDiableDialogAdd }           from './pages/material/material-form-add';
import { MaterailDiableDialogExist }           from './pages/material/material-form-add';
import { MaterialEditDialog}                 from './pages/material/material-form-edit';
import { CustomerAddDialog }                 from './pages/customer/customer-form-add';
import { CustomerDisableDialog }             from './pages/customer/customer';
import { CustomerEditDialog }                from './pages/customer/customer-form-edit';
import { SupplierDisableDialog }             from './pages/supplier/supplier';
import { SupplierAddDialog }                 from './pages/supplier/supplier-form-add';
import { SupplierEditDialog }                from './pages/supplier/supplier-form-edit';

import { ConfirmStockPlanningDialog }        from './pages/stock/stock-planning';
import { ReportFGListDialog }                from './pages/report/fg-stock-in-out-status-report';

//event
import { PageEvent }                        from './pages/event/event';
import { eventDialog }                      from './pages/event/event';
import { WarningEventDialog }               from './pages/event/event';


//mobile
//production check sheet
import { PageProductionCheckSheet }         from './pages/mobile/form-production-check-sheet';
import { PagePdCheckResult }                from './pages/mobile/pd-check-result';
import { PageQcCheckSheet }                 from './pages/mobile/form-qc-check-sheet';
import { WarningPdCheckResultDialog }       from './pages/mobile/pd-check-result';
import { pdCheckResultDialog }              from './pages/mobile/pd-check-result';
//import { PageControlChart }                 from './pages/mobile/form-control-chart';

//Extra pages
import { PageSignIn1Component }          from './pages/sign-in/sign-in';
import { signInDialog }                 from './pages/sign-in/sign-in';


@NgModule({
  declarations : [
    PageApprove,
    approveDialog,
    PagePlanSale,
    WarningsaleDeliveryPlanDialog,
    saleDeliveryPlanDialog,
    WarningApproveDialog,
    PagePermission,
    pmDialog,
    WarningPmDialog,
    PagePdCheckResult,
    supplierLoadingAddDialog,
    supplierLoadingEditDialog,
    customerLoadingAddDialog,
    customerLoadingEditDialog,
    customerLoadingAddDialog,
    homepage,
    signInDialog,
    PageEvent,
    eventDialog,
    WarningEventDialog,
    PageCheckSheetSetting,
    WarningCheckSheetSettingDialog,
    checkSheetSettingDialog,
    PageOperatorSetting,
    AppComponent,
    PageUser,
    PageUserPermission,
    PageUserAdd,
    userAddDialog,
    WarningPdCheckResultDialog,
    pdCheckResultDialog,
    userDialog,
    PageUserEdit,
    PageProcess,
    processDialog,
    WarningProcessDialog,
    PagePlanProcess,
    userEditDialog,
    PageControlChartSetting,
    DefaultLayoutComponent,
    BoxedLayoutComponent,
    operatorSettingDialog,
    WarningOperatorSettingDialog,
    DefaultCLayoutComponent,
    BoxedCLayoutComponent,
    ExtraLayoutComponent,
    machineDialog,
    PageProductionCheckSheet,
    PageQcCheckSheet,
    PageTradeTimeline,
    PageProductStandard,
    ReportFGListDialog,
    PageMachine,
    processPlanDialog,
    WarningPlanProcessDialog,
    WarningControlChartSettingDialog,
    productStandardDialog,
    lineDialog,
    controlChartSettingDialog,
    WarningMachineDialog,
    WarningProductStandardDialog,
    WarningLineDialog,
    ConfirmStockPlanningDialog,
    ProductAddDialog,
    ProductEditDialog,
    ProductDiableDialog,
    MaterailDiableDialog,
    MaterailDiableDialogAdd,
    MaterailDiableDialogExist,
    MaterialEditDialog,
    CustomerDisableDialog,
    CustomerAddDialog,
    CustomerEditDialog,
    SupplierDisableDialog,
    SupplierAddDialog,
    SupplierEditDialog,
    PageProductionLine,
    PageNotFoundComponent,
    PageTradeList,
    PageTradeDelivery,
    WarningTradBackDialog,
    PageTradeDeliveryDetail,
    tradeDialog,
    tradeListDialog,
    PageSignIn1Component,
    PageLayoutsComponent,
    PageProduct,
    PageProductEdit,
    PageProductAdd,
    PageMaterial,
    PageMaterialAdd,
    PageMaterialEdit,
    PageCustomer,
    PageCustomerAdd,
    PageCustomerEdit,
    PageSupplier,
    PageSupplierAdd,
    PageSupplierEdit,
    PageStockPlainning,
    FileDropDirective,
    FileSelectDirective
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, { useHash: true }),
    AppRoutingModule,
    UIModule,
    NIModule,
    HttpModule,
    CalendarModule.forRoot(),
    NgxDatatableModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAU9f7luK3J31nurL-Io3taRKF7w9BItQE'
    }),
    SqueezeBoxModule,
    AngularMultiSelectModule,
    ChartModule
  ],
  exports: [
  
  ],
  entryComponents: [
    PageApprove,
    approveDialog,
    WarningApproveDialog,
    PagePermission,
    pmDialog,
    WarningPmDialog,
    supplierLoadingAddDialog,
    supplierLoadingEditDialog,
    customerLoadingAddDialog,
    customerLoadingEditDialog,
    customerLoadingAddDialog,
    homepage,
    signInDialog,
    PagePlanSale,
    PagePdCheckResult,
    WarningsaleDeliveryPlanDialog,
    saleDeliveryPlanDialog,
    PageEvent,
    WarningPdCheckResultDialog,
    pdCheckResultDialog,
    eventDialog,
    WarningEventDialog,
     PageCheckSheetSetting,
     WarningCheckSheetSettingDialog,
     checkSheetSettingDialog,
     PageOperatorSetting,
     ProductDiableDialog,
     MaterailDiableDialog,
     ProductAddDialog,
     ProductEditDialog,
     PageUser,
     PageTradeList,
     PageTradeDelivery,
     WarningTradBackDialog,
     PageTradeDeliveryDetail,
     tradeDialog,
     tradeListDialog,
     PageProductionCheckSheet,
     PageProcess,
     PageTradeTimeline,
     processDialog,
     WarningLineDialog,
     WarningProcessDialog,
     processPlanDialog,
     WarningPlanProcessDialog,
     PageQcCheckSheet,
     operatorSettingDialog,
     PageUserPermission,
     PageControlChartSetting,
     lineDialog,
     PageUserAdd,
     PageProductStandard,
     WarningOperatorSettingDialog,
     PagePlanProcess,
     userAddDialog,
     WarningMachineDialog,
     userDialog,
     PageUserEdit,
     userEditDialog,
     controlChartSettingDialog,
     PageMachine,
     MaterailDiableDialogAdd,
     MaterailDiableDialogExist,
     MaterialEditDialog,
     CustomerDisableDialog,
     ReportFGListDialog,
     CustomerAddDialog,
     machineDialog,
     CustomerEditDialog,
     WarningControlChartSettingDialog,
     SupplierDisableDialog,
     SupplierAddDialog,
     WarningProductStandardDialog,
     SupplierEditDialog,
     productStandardDialog,
     PageProductionLine,
     ConfirmStockPlanningDialog
     ],
  bootstrap: [ AppComponent ]
})

export class AppModule { }



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/app.module.ts